import { i18n } from "../translations/i18n"

const useChangeLanguage = () => {

    const setLng = (lng) => {
        localStorage.setItem('systemLng', lng)
        i18n.changeLanguage(lng)
    }

    const getLng = () => {
        return localStorage.getItem('systemLng') ?? false
    }



  return {setLng, getLng}
}

export default useChangeLanguage
